var ChatterBarView = require('chatterbarview');


var LowerChatterBarView = ChatterBarView.extend({
    buttonText: '↓',
    buttonTitle: 'Scroll to end',
    className: ChatterBarView.prototype.className + ' bufferBelowExtras',
    update: function (lowerMessage, bottomSeenRow) {
        if (!lowerMessage) {
            return false;
        }
        // Update the bottom seen if we've scrolled below
        var updated = this.model.updateBottomSeen(lowerMessage);
        var bottomSeen = this.model.getBottomSeen();
        if (!bottomSeen) {
            this.hide();
            this.hideMentions();
            return false;
        }
        this.renderMentions(this.model.unseenHighlightCountAfter(bottomSeen));
        
        // Get the difference between bottom seen and last message
        var linesAgo;
        if (this.model.countMessagesBetween(bottomSeen) > 100) {
            linesAgo = true;
        } else {
            linesAgo = this.model.countImportantMessagesBetween(bottomSeen);
        }
        var bottomSeenDate;
        if (!updated && bottomSeenRow.length) {
            bottomSeenDate = new Date(bottomSeenRow.data('locked-time'));
        } else {
            bottomSeenDate = new Date();
        }
        this.renderChatter(bottomSeenDate, linesAgo);
        return updated && bottomSeenDate;
    }
});


module.exports = LowerChatterBarView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/lowerchatterbarview.js
// module id = wNhE
// module chunks = 1